import { render, staticRenderFns } from "./tuinbestrating.vue?vue&type=template&id=59e7dca6"
import script from "./tuinbestrating.vue?vue&type=script&lang=js"
export * from "./tuinbestrating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports